import Api from '@/api'


const fetchAll = () => {	
    return Api.get('api/tags')
};

const postForm =  (payload,id) => {  
    
    if(typeof id != "undefined") { 
        
        return Api.put('api/tags/' + id , payload)       
    } else {
        return Api.post('api/tags' , payload)       
    }
    
};

const getById =  (payload) => {        
    return Api.get('api/tags/' + payload)       
};

const deleteById =  (payload) => {        
    return Api.delete('api/tags/'+payload)
    
};

export default {
  fetchAll,
  postForm,
  getById,
  deleteById
};